// extracted by mini-css-extract-plugin
module.exports = {"Title":"Solutions_Title_2twKt","Text":"Solutions_Text_3ECcu"};